import { render, staticRenderFns } from "./StyleBar.vue?vue&type=template&id=5a18a70e&scoped=true"
import script from "./StyleBar.vue?vue&type=script&lang=js"
export * from "./StyleBar.vue?vue&type=script&lang=js"
import style0 from "./StyleBar.vue?vue&type=style&index=0&id=5a18a70e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a18a70e",
  null
  
)

export default component.exports